import AccessorAccessor from "./Accessor/Accessor";
import ComponentsGLTFJointComponent from "./Components/GLTFJointComponent";
import ComponentsGLTFModelComponent from "./Components/GLTFModelComponent";
import ComponentsGLTFVertexMorpher from "./Components/GLTFVertexMorpher";
import InstanciatorDefaultInstanciator from "./Instanciator/DefaultInstanciator";
import ParserConstantConverter from "./Parser/ConstantConverter";
import ParserDefaultParserModule from "./Parser/DefaultParserModule";
import ParserMaterialInstanciatorDefaultPBRMetallicRoughnessInstanciator from "./Parser/MaterialInstanciator/DefaultPBRMetallicRoughnessInstanciator";
import ParserMaterialInstanciatorGLTFMaterialInstanciatorRegistry from "./Parser/MaterialInstanciator/GLTFMaterialInstanciatorRegistry";
import ParserModulesEmbeddedBufferModule from "./Parser/Modules/EmbeddedBufferModule";
import ParserModulesIndexComplementorModule from "./Parser/Modules/IndexComplementorModule";
import ParserModulesNormalComplementorModule from "./Parser/Modules/NormalComplementorModule";
import ParserParser from "./Parser/Parser";
import ParserParserModule from "./Parser/ParserModule";
import ParserParserModuleBase from "./Parser/ParserModuleBase";
import UtilResourceResolver from "./Util/ResourceResolver";
export const __VERSION__ = "2.3.21";
export const __NAME__ = "grimoirejs-gltf";
import __MAIN__ from "./main";
let __EXPOSE__ = {
    "Accessor": {
        "Accessor": AccessorAccessor
    },
    "Components": {
        "GLTFJointComponent": ComponentsGLTFJointComponent,
        "GLTFModelComponent": ComponentsGLTFModelComponent,
        "GLTFVertexMorpher": ComponentsGLTFVertexMorpher
    },
    "Instanciator": {
        "DefaultInstanciator": InstanciatorDefaultInstanciator
    },
    "Parser": {
        "ConstantConverter": ParserConstantConverter,
        "DefaultParserModule": ParserDefaultParserModule,
        "MaterialInstanciator": {
            "DefaultPBRMetallicRoughnessInstanciator": ParserMaterialInstanciatorDefaultPBRMetallicRoughnessInstanciator,
            "GLTFMaterialInstanciatorRegistry": ParserMaterialInstanciatorGLTFMaterialInstanciatorRegistry
        },
        "Modules": {
            "EmbeddedBufferModule": ParserModulesEmbeddedBufferModule,
            "IndexComplementorModule": ParserModulesIndexComplementorModule,
            "NormalComplementorModule": ParserModulesNormalComplementorModule
        },
        "Parser": ParserParser,
        "ParserModule": ParserParserModule,
        "ParserModuleBase": ParserParserModuleBase
    },
    "Util": {
        "ResourceResolver": UtilResourceResolver
    }
};
import gr from "grimoirejs";
gr.notifyRegisteringPlugin(__NAME__);
let __BASE__ = __MAIN__();
Object.assign(__EXPOSE__, {
    __VERSION__: __VERSION__,
    __NAME__: __NAME__
});
Object.assign(__BASE__ || {}, __EXPOSE__);
window["GrimoireJS"].lib.gltf = __EXPOSE__;
export default __BASE__;



// WEBPACK FOOTER //
// ./src/index.ts